<div class="w-full max-w-md px-8 py-6 !rounded-[8px] bg-white shadow-lg">
  <div class="flex items-start justify-between gap-4">
    <div class="flex items-start gap-4">
      <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-red-50">
        <mat-icon class="text-2xl leading-none text-red-600">error</mat-icon>
      </div>
      <div class="min-w-0">
        <h2 class="text-xl font-semibold text-gray-900">{{ data.title }}</h2>
        <p class="mt-2 text-sm leading-relaxed text-gray-600 whitespace-pre-line">{{ data.message }}</p>
      </div>
    </div>
    <button
      type="button"
      mat-icon-button
      (click)="cancel()"
      class="text-gray-400 hover:text-gray-600 transition-colors duration-150"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="mt-5">
    <p class="text-xs font-medium text-gray-600">Type this code to confirm delete. Copy and paste is disabled.</p>
    <div
      class="challenge-code mt-2 rounded-md border border-red-200 bg-red-50 px-3 py-3 text-center font-mono text-lg font-semibold tracking-[0.35em] text-red-700"
      (copy)="blockCopyPaste($event)"
      (cut)="blockCopyPaste($event)"
      (contextmenu)="blockCopyPaste($event)"
      (dragstart)="blockCopyPaste($event)"
      (selectstart)="blockCopyPaste($event)"
    >
      {{ challengeCode }}
    </div>

    <mat-form-field appearance="outline" class="mt-4 w-full">
      <mat-label>Enter the code</mat-label>
      <input
        matInput
        type="text"
        name="category-delete-confirm"
        autocomplete="off"
        autocapitalize="off"
        autocorrect="off"
        spellcheck="false"
        [(ngModel)]="typedValue"
        (paste)="blockCopyPaste($event)"
        (copy)="blockCopyPaste($event)"
        (cut)="blockCopyPaste($event)"
        (drop)="blockCopyPaste($event)"
        (keydown)="blockPasteShortcut($event)"
        (contextmenu)="blockCopyPaste($event)"
      />
    </mat-form-field>
    @if(typedValue && !isMatch){
    <p class="mt-1 text-xs text-red-600">The code does not match. Please type it exactly.</p>
    }
  </div>

  <div class="mt-4 flex flex-row justify-end gap-3">
    <button
      mat-stroked-button
      type="button"
      (click)="cancel()"
      class="rounded-full border border-gray-300 bg-white px-6 py-2 text-sm font-medium text-gray-700 transition-colors duration-150 hover:bg-gray-50"
    >
      {{ cancelText }}
    </button>
    <button
      mat-stroked-button
      type="button"
      [disabled]="!isMatch"
      (click)="confirm()"
      class="rounded-full border border-red-500 bg-white px-6 py-2 text-sm font-medium text-red-600 transition-colors duration-150 hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {{ confirmText }}
    </button>
  </div>
</div>
